<template>
    <div class="filter" v-if="topFacetItems.length > 0">
        <span class="filter__title">{{categoryid}}</span>
        <ul>
            <li class="filter__item" v-for="item in topFacetItems" :key="item.name">
                <input @change="onChange" type="checkbox" v-model="selected" v-bind:value="item.id" v-bind:name="categoryid + '-' + item.id" v-bind:id="categoryid + '-' + item.id" />
                <label class="filter__item-label" v-bind:for="categoryid + '-' + item.id">{{item.label}} ({{item.count}})</label><br>
            </li>
            <li v-if="facetitems.length > 8" class="filter__more" @click="onSearchClick()">
                <img class="filter__more-icon" src="\Themes\Striep2\Content\svg\search-blue.svg" />
                <span class="filter__more-label">Meer</span>
            </li>
        </ul>
    </div>
</template>

<script>
   export default {
        name: 'product-page-filter-component',
        props: ['categoryid', 'facetlabel', 'facetitems', 'selectedinput'],
        data: function () {
            return {
                selected: this.selectedinput
            }
        },
        computed: {
            topFacetItems: function () {
                if (this.facetitems)
                    return this.facetitems.slice(0, 5);
                return [];
            }
        },
        watch: {
            selectedinput(val, oldVal) {
                if (val !== oldVal) this.selected = val;
            }
        },
        methods: {
            onChange: function () {
                this.$emit("facetsselected", this.selected, this.categoryid);
            },
            onSearchClick: function () {
                document.querySelector('.master-wrapper-content').style.zIndex = "1"
                this.$emit("searchfacet", this.categoryid);
            }
        }
    }
</script>